import { useState, type ReactNode } from 'react';
import { AccountDialog } from '@/components/account/AccountDialog';
import { useCurrentUser } from '@/hooks/useAuth';
import { Sidebar } from '@/components/layout/Sidebar';
import { usePreferences } from '@/store/preferencesStore';

/** The signed-in frame: the sidebar, and the page the address names beside it. */
export function Shell({ onSignedOut, children }: { readonly onSignedOut: () => void; readonly children: ReactNode }): ReactNode {
  const [account, setAccount] = useState(false);
  const me = useCurrentUser();
  const collapsed = usePreferences((state) => state.sidebarCollapsed);

  return (
    <div className={collapsed ? 'app app-collapsed' : 'app'}>
      <Sidebar onOpenAccount={() => setAccount(true)} onSignedOut={onSignedOut} />

      <main className="content">{children}</main>

      {me.data ? <AccountDialog open={account} user={me.data} onClose={() => setAccount(false)} /> : null}
    </div>
  );
}
